<template>
  <b-sidebar
    id="add-new-booking-sidebar"
    :visible="isEventHandlerSidebarUpdateActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @hidden="$emit('hidden');"
    @change="(val) => $emit('one')"
  >
    <template>
<div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{bookingData.event.title}} #{{bookingData.event.id}}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="$emit('hidden')"
        />

      </div>



       <validation-observer
        ref="simpleRules"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
        <label class="section-label mb-1">Class Details</label>



<!-- readonly input -->



                  <b-list-group>
                    <b-list-group-item v-for="(booking, index) in class_detail.booking" :key="index" >
                      <b-row>
                        <b-col md="3">
                          {{booking.code}}
                        </b-col>
                        <b-col md="5">
                          <span>
                            <b>{{booking.rank}}.
                              {{booking.zh_name}}</b>
                          </span>
                          <br>
                          -
                          {{booking.todo_category}}
                          <br>
                          <span style="color:#888;">-
                            {{booking.todo_content}}</span>
                          <br>
                          <span style="color:#888;">-
                            {{booking.todo_tools}}</span>

                        </b-col>
                        <!-- <b-col md="4" class="text-right">
                          <feather-icon v-if="booking.status != 'LEAVE' && booking.is_attend == null " @click="absent(booking.id)" icon="EyeOffIcon" color="warning" class="feather mr-1 pointer" />
                          <feather-icon v-if="booking.is_attend !='Y' " @click="change(booking.id)" icon="ShuffleIcon" color="red" class="feather mr-1 pointer" />
                          <feather-icon v-if="booking.status != 'LEAVE' && booking.is_attend !='Y' " @click="attend(booking.id)" icon="CheckSquareIcon" color="green" class="feather mr-1 pointer" />
                          <feather-icon v-if="booking.is_attend =='Y' " icon="CheckIcon" color="blue" />
                        </b-col> -->
                      </b-row>
                    </b-list-group-item>

                  </b-list-group>

         <b-button
              class="mt-2"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              block
              v-if="bookingData.signature_created_at === null"
              variant="outline-secondary"
              @click="$emit('hidden')"
            >
              Back
            </b-button>


          <div>


          <img v-if="bookingData.signature_created_at !== null" :src="bookingData.signature" style="width:100%" class="mt-1">
        </div>
        <br><br><br><br><br><br><br><br>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BModal, VBModal,BFormTimepicker,BListGroup,
  BListGroupItem,  BRow,
    BCol,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import countries from '@/@fake-db/data/other/countries'

export default {
  components: {
    ToastificationContent,
    BFormTimepicker,
    flatPickr,
    BSidebar,
    BForm,
    moment,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BRow,
    BCol,
    BModal, VBModal,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  watch: {
    isEventHandlerSidebarUpdateActive: function(n,o) {
      if (n === true) {
        console.log(this.bookingData.event)
        console.log(moment(this.bookingData.event.start).format('YYYY-MM-DD'))
        this.get_class_detail(this.bookingData.event.id,moment(this.bookingData.event.start).format('YYYY-MM-DD'))
      }
    },
    bookingData : function(newValue,oldValue) {
      //this.newBookingData.user_id = newValue.user_id
    }
  },
  model: {
    prop: 'isEventHandlerSidebarUpdateActive',
    event: 'update:is-add-new-Member-sidebar-active'
  },
  props: {
    isEventHandlerSidebarUpdateActive:{
      type: Boolean,
      require: true,
    },
    bookingData:{
      type: Object,
      require: true,
    }
  },
  data() {
    return {
      newBookingData: {},
      current_user_id : JSON.parse(localStorage.getItem('userData')).id,
      staffOptions: [],
      memberOptions : [],
      roomOptions : [],
      member_id: null,
      memberPackageOptions : [],
      required,
      end_at: null,
      paymentMethodOptions: [
        { label: 'Cash', value: 'cash' },
        { label: 'Visa', value: 'visa' },
      ],
      lock_quantity : true,
      alphaNum,
      email,
      class_detail:{},
      countries,
      booking:{
        member_id:null
      },
      blankBookingData: {
        room_id:null,
        member_package_id:null,
        member_id:{
          labal:'',
          value:''
        },
        start:null,
        end:null
      },

    }
  },
  methods: {
    get_class_detail(class_id, class_date) {
      this.$http.get(process.env.VUE_APP_API_BASE + '/class/' + class_id + '/?class_date=' + class_date)
        .then(res => {
          this.class_detail = res.data
        })
    },

    submit_now() {
          this.$http.post(process.env.VUE_APP_API_BASE+'/booking/'+this.newBookingData.booking_id+"/", this.newBookingData)
            .then(res => {
              if (res.data.result === true) {
                this.$emit('hidden')
                this.booking = this.blankBookingData
                this.$refs.simpleRules.reset()
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-center',
                  props: {
                    title: 'Error',
                    icon: 'XIcon',
                    variant: 'danger',
                    text: res.data.message,
                  },
                })
              }
            })
    }
  },
  setup(props, { emit }) {
    const blankPackageData = {
      expire_at:'',
      quantity:'',
      package: {
        expiry_figure:'1',
        expiry_unit:'DAY'
      }
    }

    const packageData = ref(JSON.parse(JSON.stringify(blankPackageData)))
    const resetuserData = () => {
      packageData.value = JSON.parse(JSON.stringify(blankPackageData))
    }

    const onSubmit = () => {

    }

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(resetuserData)

    return {
      packageData,
      onSubmit,

      refFormObserver,
      getValidationState,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
